module.exports = __webpack_public_path__ + "img/cent-exp-and-offers.05a5ce8a.jpg";